import React from "react";
import "./style.css";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-in">
      <h1>Privacy Policy</h1>
    <p>Effective Date: 02/06/2025</p>
    <p>Welcome to CGTHomes. Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website or use our services.</p>

    <h2>1. Information We Collect</h2>
    <p>We collect various types of information to provide and improve our services, including:</p>
    <ul>
        <li>Personal Information: Name, email address, phone number, and home address.</li>
        <li>Transaction Data: Property preferences, inquiries, and purchases.</li>
        <li>Technical Data: IP address, browser type, device information, and cookies.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use the collected data for the following purposes:</p>
    <ul>
        <li>To provide, operate, and maintain our website and services.</li>
        <li>To process transactions and communicate with you.</li>
        <li>To personalize your experience based on your preferences.</li>
        <li>To analyze usage trends and improve our platform.</li>
        <li>To comply with legal obligations and enforce our policies.</li>
    </ul>

    <h2>3. Sharing of Information</h2>
    <p>We do not sell or rent your personal information. However, we may share your data with:</p>
    <ul>
        <li>Service providers assisting in website maintenance, payment processing, and marketing.</li>
        <li>Legal authorities if required by law or to protect our rights.</li>
        <li>Business partners for collaborative real estate opportunities.</li>
    </ul>

    <h2>4. Data Security</h2>
    <p>We implement industry-standard security measures to protect your information. However, no method of transmission over the internet is 100% secure. We encourage you to take precautions when sharing personal information online.</p>

    <h2>5. Your Rights and Choices</h2>
    <p>You have the right to:</p>
    <ul>
        <li>Access, update, or delete your personal data.</li>
        <li>Opt-out of marketing communications.</li>
        <li>Restrict or object to the processing of your data.</li>
    </ul>

    <h2>6. Cookies and Tracking Technologies</h2>
    <p>We use cookies and similar tracking technologies to enhance your browsing experience. You can modify your browser settings to disable cookies, but this may affect website functionality.</p>

    <h2>7. Third-Party Links</h2>
    <p>Our website may contain links to third-party websites. We are not responsible for their privacy practices, and we encourage you to review their policies before providing any personal information.</p>

    <h2>8. Updates to This Privacy Policy</h2>
    <p>We may update this Privacy Policy periodically. Any changes will be posted on this page with the updated effective date.</p>

    <h2>9. Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>
    {/* <p>Phone: +919513280298</p> */}
    </div>
    </div>
  );
}

export default PrivacyPolicy;
